import {ColorModeScript} from '@chakra-ui/react';
import React, {StrictMode} from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import './i18n';
import {HelmetProvider} from 'react-helmet-async';
// New UI design system — loaded globally so any .nx-scoped page (G2/G4+)
// can use it without per-page imports. Scope isolation is via the .nx
// selector prefix, not via code-splitting. ~25KB raw, ~6KB gzip.
import 'style/css/newui.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
    <StrictMode>
        <HelmetProvider>
            <ColorModeScript />
            <App />
        </HelmetProvider>
    </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
